import type { TeamMember } from '../types/content';

/**
 * Public team directory — edit names, titles and photographs here.
 *
 * Privacy: do NOT add email addresses, phone numbers or other personal
 * contact details to this file. It ships to the browser and is public.
 * Each `id` is the routing key a secure backend uses to look up the
 * partner's private recipient address (stored server-side only).
 *
 * To show an approved professional photograph, set `photo` to a full image URL.
 * Until then, an initials monogram is displayed automatically.
 */
export const teamMembers: TeamMember[] = [
  { id: 'peter', name: 'Peter', title: 'Search Executive Partner' },
  { id: 'favour-precious', name: 'Favour Precious', title: 'Search Executive Partner' },
  { id: 'musa-a', name: 'Musa A', title: 'Search Executive Partner' },
  { id: 'david', name: 'David', title: 'Search Executive Partner' },
  { id: 'goodluck', name: 'Goodluck', title: 'Search Executive Partner' },
];

export const partnerInquirySubject = 'Executive Search Inquiry — Avenqor Talent Search';
